import React from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { phoneModalNumberState, phoneModalState } from './atom'
import { ModalBase, Text,Stack } from '@/presentation/components'
import { Linking, Alert } from 'react-native';
import { theme } from '@/presentation/styles';
import { Button } from 'react-native-paper';

export const PhoneModal: React.FC = () => {
  const [modalIsOpen, setModalOpen] = useRecoilState(phoneModalState)
  const phoneNumber = useRecoilValue(phoneModalNumberState)

  if (!phoneNumber) {
    return null
  }

  const treatedPhoneNumber = phoneNumber.split(":")[1];

  const handleCloseModal = (): void => {
    setModalOpen(false)
  }

  const handleCall = async () => {
    const url = `tel:${phoneNumber}`;
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      await Linking.openURL(url);
    } else {
      Alert.alert('Error', 'Erro ao ligar');
    }
  };

  return (
    <ModalBase
      visible={modalIsOpen}
      onClose={handleCloseModal}
      key={`id-${phoneNumber}`}
    >
      <Text variant='h6'>Contato</Text>
      <Stack style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <Text variant='body1'>{`Fale conosco através do fone: ${treatedPhoneNumber}`}</Text>
        <Button
          icon='phone'
          onPress={handleCall}
          buttonColor={theme.colors.info}
          textColor={theme.colors.white}
        >
          Ligar
        </Button>
      </Stack>
    </ModalBase>
  )
}
